import React, {ReactNode} from "react"
import {FavouritesBadge as Badge} from "./component"

export type StandardBadgeProps = {
    hideBadge: boolean
    children: ReactNode
}

export const StandardBadge = ({hideBadge, children}: StandardBadgeProps) => {
    return (
        <Badge
            variant="dot"
            invisible={hideBadge}
            overlap="circular"
            data-testid={`header-fav-badge-${`${hideBadge ? "in" : ""}active`}`}
        >
            {children}
        </Badge>
    )
}

export default StandardBadge
